// Экспорт скриншотов для продуктов
export const screenshots = {
  saInventory1: "/images/inventory/1.png",
  saInventory2: "/images/inventory/2.png",
  saInventory3: "/images/inventory/3.png"
}; 